import { TicketReasonsQueries } from '@/graphql/queries/ticketReasons.queries'
import { TicketReason, TicketReasonFilterParams } from '@/types/TicketReason'

import { useGraphql } from '../useGraphql'

const useTicketReasons = () => {
  const filterParams: Partial<TicketReasonFilterParams> = {
    active: true,
  }
  const ticketReasonsQuery = useGraphql<{ ticketReasons: TicketReason[] }>(
    TicketReasonsQueries.QUERY_KEY,
    TicketReasonsQueries.getTicketReasons(),
    { filter: filterParams },
  )
  return ticketReasonsQuery
}

export default useTicketReasons
